module.exports = __webpack_public_path__ + "static/media/fb-share.8f52dfd1.svg";